import React from 'react'
import { connect } from 'react-redux'
import { Box, Divider, Grid, Select, MenuItem, Button, TextField } from '@material-ui/core'
import { viewStyles, buttonStyles } from '../styles/styles'
import RightPreviewPart from './RightPreviewPart'
import FormElementsList from './FormElementsList'
import OptionList from './OptionsList'
import { elements } from '../defaults/elements'
import { 
    selectElementForAddingToForm, 
    addNewElement
 } from '../actions/settings'
import CancelFormButton from '../containers/CancelFormButton'


const ViewEdit = ({ settings, selectElementForAdd, addElementToList }) => {
    const classes = viewStyles()
    const btnStyles = buttonStyles()
    const handleChange = (event, child) => {
        //selectElementForAdd(event.target.value)
        addElementToList(event.target.value)

    }

    const showValue = (element) => {
        return element.title
    }    

    return (
        <Box className={classes.box_view}>
            <Box className={classes.leftBox}>
                <Box m="10px 0 20px 0" className={classes.titleLeft}>
                    Customize the form template to your liking
                </Box>                
                <Grid container spacing={3} justifyContent="space-between">
                    <Grid item xs={6}>
                        <Box className={classes.selectContainer}>
                            <TextField
                                id="field-dropdown"
                                className={[classes.settingsFieldText, classes.selectList].join(' ')}
                                value={settings.selectedElementFromList}
                                defaultValue={settings.selectedElementFromList}
                                onChange={handleChange}
                                rendervalue={element => element.title}
                                label="Add New Field:"
                                margin="normal"
                                select={true}
                                placeholder="Choose element"
                            >
                                {
                                    elements.map((elm) => {
                                        return (
                                            <MenuItem key={elm.id} value={elm}>{elm.title}</MenuItem>
                                        )
                                    })
                                }
                            </TextField>
                        </Box>                        
                    </Grid>
                    <Grid item xs={6}></Grid>
                    <Grid item xs={6}>
                        <div className={classes.verticalLine}>
                            <FormElementsList></FormElementsList>
                        </div>                       
                    </Grid>
                    <Grid item xs={6}>
                        <OptionList></OptionList>
                    </Grid>
                </Grid>
                {/* <Box className={classes.bottomBox}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Select className={classes.selectList} value={settings.selectedElementFromList} onChange={handleChange} renderValue={showValue}>
                                {
                                    elements.map((elm) => {
                                        return (
                                            <MenuItem key={elm.id} value={elm}>{elm.title}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid item xs={6}>
                            <Button className={btnStyles.add} onClick={() => addElementToList(settings.selectedElementFromList)}>add</Button>
                        </Grid>
                    </Grid>
                </Box> */}
            </Box>
            <Box className={classes.bottomBox} m="5px 0 5px 0px">
                <Grid item xs={2}>
                    <CancelFormButton />
                </Grid>
            </Box>
            <Divider orientation="vertical" className={classes.devider}></Divider>
            <Box className={classes.rightBox}>
                <RightPreviewPart></RightPreviewPart>
            </Box>                                  
        </Box>
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
     selectElementForAdd: element => dispatch(selectElementForAddingToForm(element)),
     addElementToList: elm => dispatch(addNewElement(elm))
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewEdit)